export default "__VITE_PUBLIC_ASSET__53de28c1__"